<div *ngIf="!searchActive">
  <!-- <app-banner-post [posts]="bannerPosts"></app-banner-post> -->
  <div class="banner-post">
    <img [src]="'assets/img/banners/antecipacao.png'" alt="" />
    <div class="container">
      <div class="text-area">
        <h1>Blog da azulzinha</h1>
        <p class="mt-4">
          Fique por dentro das dicas, tutoriais, tendências de mercado e
          novidades da maquininha da CAIXA.
        </p>
        <div class="mt-4">
          <a class="btn btn-primary" href="/blog#dobra">Veja mais</a>
        </div>
      </div>
    </div>
  </div>
</div>
<header
  id="dobra"
  [ngClass]="searchActive ? 'search-container' : ''"
  class="header-busca container"
>
  <div class="container-busca">
    <div class="container content-buscar">
      <div class="d-flex w-100 justify-content-between">
        <input
          [(ngModel)]="searchTerm"
          placeholder="O que você procura?"
          (keydown.enter)="filteredPosts()"
          type="text"
        />
      </div>
      <div class="container-button">
        <button class="btn-filter" (click)="showModal = true">
          <img
            class="icon-filter"
            src="../../../assets/img/icons/filter-solid.svg"
            alt=""
          />
        </button>
        <button class="btn-primary" (click)="filteredPosts()">Pesquisar</button>
        <div
          class="btn-primary btn-blue"
          (click)="handleToBack()"
          *ngIf="searchActive"
        >
          Voltar
        </div>
      </div>
    </div>
  </div>
</header>
<div *ngIf="!searchActive">
  <app-destaques-post [posts]="destaquePosts"> </app-destaques-post>
  <app-destaques-post-filter [posts]="posts"> </app-destaques-post-filter>
  <app-latest-post *ngIf="posts.length > 0" [posts]="posts"></app-latest-post>
  <div class="container text-center mt-4">
    <a (click)="showAllPosts()" class="text-orange">Ver mais</a>
  </div>
</div>

<div class="container">
  <h2
    style="color: #0060af !important"
    class="mb-4 mt-4"
    *ngIf="searchActive && !viewAllPosts && filteredPost.length > 0"
  >
    Resultados para
    <span *ngIf="searchTerm">"{{ searchTerm }}"</span>
    <span *ngIf="selectedCategory && !searchTerm"
      >"{{ selectedCategory }}"</span
    >
  </h2>
  <h2
    style="color: #0060af !important"
    class="mb-4 mt-4"
    *ngIf="searchActive && !viewAllPosts && !(filteredPost.length > 0)"
  >
    Nenhum resultado encontrado
  </h2>
  <div class="post-grid">
    <div *ngIf="searchActive && !viewAllPosts" class="post-grid row">
      <div *ngFor="let post of filteredPost" class="post-card">
        <img
          [src]="env.origin + '/blogmidias/' + post.postId + '.jpg'"
          alt="{{ post.altImg }}"
        />
        <div class="post-details">
          <div class="footer">
            <div class="d-flex">
              <!-- <span class="category">{{post.category[0]}}</span>
              <span *ngIf="post.category.length > 1" class="category count">
                {{ '+' + (post.category.length - 1)}}</span> -->
            </div>
            <span class="date">{{
              parseDate(post.date) | date : 'dd/MM/yyyy'
            }}</span>
          </div>
          <p class="text-orange">
            <a
              target="_blank"
              style="color: #0060af"
              [routerLink]="['/blog', post.postId]"
              >{{ post.title }}</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="post-grid" *ngIf="searchActive && viewAllPosts">
    <div *ngFor="let post of posts" class="post-card">
      <img
        [src]="env.origin + '/blogmidias/' + post.postId + '.jpg'"
        alt="{{ post.altImg }}"
      />
      <div class="post-details">
        <div class="footer">
          <div class="d-flex"></div>

          <span class="date">{{
            parseDate(post.date) | date : 'dd/MM/yyyy'
          }}</span>
        </div>
        <p class="text-orange">
          <a
            target="_blank"
            style="color: #0060af"
            [routerLink]="['/blog', post.postId]"
            >{{ post.title }}</a
          >
        </p>
      </div>
    </div>
  </div>
</div>

<div class="promotion-banner container">
  <div class="box-principal">
    <div class="bg-blue">
      <div class="img-mobile">
        <img src="assets/img/bg-mulher-maquina-na-mao.png" alt="" />
      </div>
      <div class="box-blue">
        <h2>Com a azulzinha da CAIXA você pode muito mais!</h2>
        <div class="text-area">
          <p>
            Preencha o formulário e receba uma oferta personalizada para seu
            negócio, com as melhores taxas e condições que só a CAIXA pode
            oferecer para você.
          </p>
        </div>
        <div>
          <a class="cta btn btn-primary" routerLink="/peca-azulzinha"
            >Peça já a sua azulzinha</a
          >
        </div>
      </div>
    </div>
    <div class="box-img">
      <img src="assets/img/mulher-com-maquina-1.png" alt="" />
    </div>
    <div class="bg-img">
      <img src="assets/img/bg-loja-de-roupas.png" alt="" />
    </div>
  </div>
</div>

<app-modal [(isOpen)]="showModal">
  <div class="container-modal">
    <div class="form-group">
      <label for="category-select">Selecione uma categoria:</label>
      <select
        id="category-select"
        [(ngModel)]="selectedCategory"
        class="form-control mt-3"
      >
        <option value="" disabled selected>Selecione uma opção</option>
        <option *ngFor="let option of categories" [value]="option">
          {{ option }}
        </option>
      </select>
    </div>

    <div class="mt-3">
      <p>
        Categoria selecionada:
        <span style="color: #0060af; font-weight: bold">{{
          selectedCategory || 'Nenhuma selecionada'
        }}</span>
      </p>
      <div class="text-center mt-5">
        <button class="btn-primary btn-big" (click)="filteredCategoryPost()">
          Pesquisar
        </button>
      </div>
    </div>
  </div>
</app-modal>
